/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsSquarePowerpoint: {
  name: 'square-powerpoint';
  data: string;
} = {
  name: 'square-powerpoint',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M2 .5A1.5 1.5 0 0 0 .5 2v12A1.5 1.5 0 0 0 2 15.5h12a1.5 1.5 0 0 0 1.5-1.5V2A1.5 1.5 0 0 0 14 .5H2ZM1.5 2a.5.5 0 0 1 .5-.5h12a.5.5 0 0 1 .5.5v12a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5V2ZM6 4.5a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 1 0V9.5H8a2.5 2.5 0 0 0 0-5H6Zm2 4H6.5v-3H8a1.5 1.5 0 1 1 0 3Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
